import { defineMessages } from 'react-intl';

const tableHeadMessages = defineMessages({
  shiftId: {
    id: 'CalendarTableHeaders.shiftId',
    defaultMessage: 'Shift ID',
  },
  date: {
    id: 'CalendarTableHeaders.date',
    defaultMessage: 'Date',
  },
  owner: {
    id: 'CalendarTableHeaders.owner',
    defaultMessage: 'Requested By',
  },
  coverer: {
    id: 'CalendarTableHeaders.applicant',
    defaultMessage: 'Covered By',
  },
  startAt: {
    id: 'CalendarTableHeaders.startAt',
    defaultMessage: 'Start Time',
  },
  endAt: {
    id: 'CalendarTableHeaders.endAt',
    defaultMessage: 'End Time',
  },
  tradeStatus: {
    id: 'CalendarTableHeaders.tradeStatus2',
    defaultMessage: 'Status',
  },
  position: {
    id: 'CalendarTableHeaders.position',
    defaultMessage: 'Position',
  },
  shiftNotes: {
    id: 'CalendarTableHeaders.shiftNotes',
    defaultMessage: 'Notes',
  },
  type: {
    id: 'CalendarTableHeaders.type',
    defaultMessage: 'Type',
  },
  channel: {
    id: 'CalendarTableHeaders.channel',
    defaultMessage: 'Channel',
  },
  timeRange: {
    id: 'CalendarTableHeaders.timeRange',
    defaultMessage: 'Time Range',
  },
  skills: {
    id: 'CalendarTableHeaders.skills',
    defaultMessage: 'Skills',
  },
});


export const CalendarTableHeadersWithSkills = [
  {
    title: tableHeadMessages.type,
    key: 'name',
    type: 'enum',
  },
  {
    title: tableHeadMessages.date,
    key: 'start_at',
    type: 'date',
  },
  {
    title: tableHeadMessages.channel,
    key: 'channel_name',
    type: 'text',
  },
  {
    title: tableHeadMessages.owner,
    key: 'owner',
    type: 'user',
  },
  {
    title: tableHeadMessages.coverer,
    key: 'coverer',
    type: 'user',
  },
  {
    title: tableHeadMessages.timeRange,
    key: ['start_at', 'end_at'],
    type: 'time_range',
  },
  {
    title: tableHeadMessages.tradeStatus,
    key: 'trade_status',
    type: 'enum',
  },
  {
    title: tableHeadMessages.shiftNotes,
    key: 'content',
    type: 'text',
  },
  {
    title: tableHeadMessages.skills,
    key: 'skill_ids',
    type: 'skills',
  },
];

export const CalendarTableHeaders = [
  {
    title: tableHeadMessages.type,
    key: 'name',
    type: 'enum',
  },
  {
    title: tableHeadMessages.date,
    key: 'start_at',
    type: 'date',
  },
  {
    title: tableHeadMessages.channel,
    key: 'channel_name',
    type: 'text',
  },
  {
    title: tableHeadMessages.owner,
    key: 'owner',
    type: 'user',
  },
  {
    title: tableHeadMessages.coverer,
    key: 'coverer',
    type: 'user',
  },
  {
    title: tableHeadMessages.timeRange,
    key: ['start_at', 'end_at'],
    type: 'time_range',
  },
  {
    title: tableHeadMessages.tradeStatus,
    key: 'trade_status',
    type: 'enum',
  },
  {
    title: tableHeadMessages.shiftNotes,
    key: 'content',
    type: 'text',
  },
];

const csvHeadMessages = defineMessages({
  shiftNotes: {
    id: 'csvHeadMessages.shiftNotes',
    defaultMessage: 'Notes',
  },
  position: {
    id: 'csvHeadMessages.position',
    defaultMessage: 'Position',
  },
  type: {
    id: 'csvHeadMessages.type',
    defaultMessage: 'Type',
  },
  timeZone: {
    id: 'csvHeadMessages.timeZone',
    defaultMessage: 'Time Zone',
  },
  timePosted: {
    id: 'csvHeadMessages.timePosted',
    defaultMessage: 'Time Posted',
  },
  timeCovered: {
    id: 'csvHeadMessages.timeCovered',
    defaultMessage: 'Time Applied',
  },
  managerName: {
    id: 'csvHeadMessages.managerName',
    defaultMessage: 'Manager Name',
  },
  timeManaged: {
    id: 'csvHeadMessages.timeManaged',
    defaultMessage: 'Time Managed',
  },
  locationName: {
    id: 'csvHeadMessages.locationName',
    defaultMessage: 'Location Name',
  },
  address: {
    id: 'csvHeadMessages.address',
    defaultMessage: 'Address',
  },
  shiftDuration: {
    id: 'csvHeadMessages.shiftDuration',
    defaultMessage: 'Shift Duration',
  },
});

export const CalendarCsvHeaders = [
   {
    title: tableHeadMessages.shiftId,
    key: 'id',
    type: 'string',
  },
  {
    title: tableHeadMessages.owner,
    key: 'owner',
    type: 'user',
  },
  {
    title: tableHeadMessages.type,
    key: 'name',
    type: 'enum',
  },
  {
    title: tableHeadMessages.channel,
    key: 'channel_name',
    type: 'text',
  },
  {
    title: tableHeadMessages.startAt,
    key: 'start_at',
    type: 'time',
  },
  {
    title: tableHeadMessages.endAt,
    key: 'end_at',
    type: 'time',
  },
  {
    title: csvHeadMessages.shiftDuration,
    key: ['start_at', 'end_at'],
    type: 'duration',
  },
  {
    title: csvHeadMessages.position,
    key: 'primary_job',
    type: 'string',
  },
  {
    title: csvHeadMessages.shiftNotes,
    key: 'content',
    type: 'string',
  },
  {
    title: tableHeadMessages.coverer,
    key: 'coverer',
    type: 'user',
  },
  {
    title: tableHeadMessages.tradeStatus,
    key: 'trade_status',
    type: 'enum',
  },

  {
    title: csvHeadMessages.timePosted,
    key: 'created_at',
    type: 'time',
  },
  {
    title: csvHeadMessages.timeCovered,
    key: 'coverer_time',
    type: 'time',
  },
  {
    title: csvHeadMessages.managerName,
    key: 'approver',
    type: 'user',
  },
  {
    title: csvHeadMessages.timeManaged,
    key: 'manager_time',
    type: 'time',
  },
    {
    title: csvHeadMessages.timeZone,
    key: 'time_zone',
    type: 'time_zone',
  },
  {
    title: csvHeadMessages.locationName,
    key: 'location_name',
    type: 'location_name',
  },
  {
    title: csvHeadMessages.address,
    key: 'formatted_address',
    type: 'location_address',
  },
];

export const CsvExportHeadersWithSkills = [
  {
    title: tableHeadMessages.shiftId,
    key: 'id',
    type: 'string',
  },
  {
    title: tableHeadMessages.owner,
    key: 'owner',
    type: 'user',
  },
  {
    title: tableHeadMessages.type,
    key: 'name',
    type: 'enum',
  },
  {
    title: tableHeadMessages.channel,
    key: 'channel_name',
    type: 'text',
  },
 
  {
    title: tableHeadMessages.startAt,
    key: 'start_at',
    type: 'time',
  },
  {
    title: tableHeadMessages.endAt,
    key: 'end_at',
    type: 'time',
  },
  {
    title: csvHeadMessages.shiftDuration,
    key: ['start_at', 'end_at'],
    type: 'duration',
  },
   {
    title: csvHeadMessages.position,
    key: 'primary_job',
    type: 'string',
  },
   {
    title: csvHeadMessages.shiftNotes,
    key: 'content',
    type: 'string',
  },
   {
    title: tableHeadMessages.coverer,
    key: 'coverer',
    type: 'user',
  },
  {
    title: tableHeadMessages.tradeStatus,
    key: 'trade_status',
    type: 'enum',
  },
  {
    title: csvHeadMessages.timePosted,
    key: 'created_at',
    type: 'time',
  },
  {
    title: csvHeadMessages.timeCovered,
    key: 'coverer_time',
    type: 'time',
  },
  {
    title: csvHeadMessages.managerName,
    key: 'approver',
    type: 'user',
  },
  {
    title: csvHeadMessages.timeManaged,
    key: 'manager_time',
    type: 'time',
  },
    {
    title: csvHeadMessages.timeZone,
    key: 'time_zone',
    type: 'time_zone',
  },
  {
    title: csvHeadMessages.locationName,
    key: 'location_name',
    type: 'location_name',
  },
  {
    title: csvHeadMessages.address,
    key: 'formatted_address',
    type: 'location_address',
  },
  {
    title: tableHeadMessages.skills,
    key: 'skill_ids',
    type: 'skills',
  },
];

export const CalendarShiftTypes = defineMessages({
  vto: {
    id: 'Calendar.vto',
    defaultMessage: 'VTO',
  },
  teamShift: {
    id: 'Calendar.teamShift',
    defaultMessage: 'Team Shift',
  },
  openShift: {
    id: 'Calendar.openShift',
    defaultMessage: 'Open Shift',
  },
});

const calendarFilterMessages = {
  approved: {
    id: 'FilterContainer.approved',
    defaultMessage: 'Approved',
  },
  denied: {
    id: 'FilterContainer.denied',
    defaultMessage: 'Denied',
  },
  posted: {
    id: 'FilterContainer.posted',
    defaultMessage: 'Posted',
  },
  pending: {
    id: 'FilterContainer.pending',
    defaultMessage: 'Pending',
  },
  covered: {
    id: 'FilterContainer.covered',
    defaultMessage: 'Covered',
  },
};

export const closedLocationCalendarFilters = [
  {
    label: calendarFilterMessages.approved,
    value: 'approved',
    checked: false,
  },
  {
    label: calendarFilterMessages.denied,
    value: 'rejected',
    checked: false,
  },
  {
    label: calendarFilterMessages.posted,
    value: 'posted',
    checked: false,
  },
  {
    label: calendarFilterMessages.pending,
    value: 'pending',
    checked: false,
  },
];

export const openLocationCalendarFilters = [
  {
    label: calendarFilterMessages.covered,
    value: 'covered',
    checked: false,
  },
  {
    label: calendarFilterMessages.posted,
    value: 'posted',
    checked: false,
  },
];
